const onDomReady = new Promise(resolve => {
  document.addEventListener('DOMContentLoaded', () => {
    resolve();
  });
});

export { onDomReady };